import { render, staticRenderFns } from "./duowei.vue?vue&type=template&id=233bfba0&scoped=true&"
import script from "./duowei.vue?vue&type=script&lang=ts&"
export * from "./duowei.vue?vue&type=script&lang=ts&"
import style0 from "./duowei.vue?vue&type=style&index=0&id=233bfba0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233bfba0",
  null
  
)

export default component.exports